import React, { useEffect, useState } from 'react';
import { Button, Text, View } from "../../Components/Themed"
import type { AthleteProps, GolfLeaderProps, MarketProps, OrderProps } from '../../types';
import { AthleteImage } from '../../Components/Jerseys';
import { useColors } from '../../constants/useColors';
import { GolfHelpers } from '../api';
import { FlatList } from 'react-native';
import { Icons, Toggle } from '../../Components';

type LeaderBetsListProps = {
    golf_leader:GolfLeaderProps,
    athlete:AthleteProps,
    orders:OrderProps[],
    max_height?:number,
    markets:MarketProps[],
    active_round?:number,
    onClose:() => void
}
const sections = ['header','toggle','list']
const LeaderBetsList = ({ golf_leader, athlete, orders, markets, max_height, active_round, onClose }:LeaderBetsListProps) => {
    const Colors = useColors();
    const [ active_toggle, setActiveToggle ] = useState('active');
    const current_hole = GolfHelpers.getCurrentHole(golf_leader, active_round);
    let leader_orders = orders.filter(o => o.side_id == athlete.athlete_id);
    if(active_toggle == 'active'){
        leader_orders = leader_orders.filter(o => o.resolution_status == 'inprogress');
    } else {
        leader_orders = leader_orders.filter(o => o.resolution_status == 'closed')
    }

    useEffect(() => {
        let filtered_orders = orders.filter(o => o.side_id == athlete.athlete_id);
        let is_active = filtered_orders.find(o => o.resolution_status == 'inprogress');
        if(is_active){ setActiveToggle('active') }
        else { setActiveToggle('closed') }
    },[orders.length])

    const getIcon = (result_ind?:string) => {
        switch(result_ind){
            case 'win': return <Icons.CheckIcon size={16} color={Colors.text.success} />
            case 'lose': return <Icons.CloseIcon size={16} color={Colors.text.error} />
            case 'draw': return <Icons.CheckIcon size={16} color={Colors.text.descriptionLight} />
            default: return <Icons.ActivityIcon size={16} color={Colors.text.action} />
        }
    }
    const getColor = (result_ind?:string) => {
        switch(result_ind){
            case 'win': return Colors.text.success
            case 'lose': return Colors.text.error
            case 'draw': return Colors.text.descriptionLight
            default: return Colors.text.h1
        }
    }
    const renderOrders = (data:{ item:OrderProps, index:number }) => {
        let market = markets.find(mk => mk.market_id == data.item.market_id);
        if(!market){ return <></> }
        const order_stats = GolfHelpers.calcAllOrderStats([data.item]);
        return (
            <View style={{ flexDirection:'row', alignItems:'center', borderBottomWidth:1, borderColor:Colors.borders.light, padding:10 }}>
                <View float style={{ padding:5 }}>
                    {getIcon(order_stats.result_ind)}
                </View>
                <View style={{ flex:1, marginLeft:10 }}>
                    <Text theme='h1'>Hole: {market.length_variable}</Text>
                    <Text theme='description' style={{ marginTop:3 }}>{data.item.title}</Text>
                </View>
                {order_stats.result_ind ?
                <View style={{ flexDirection:'row', alignItems:'center', marginLeft:10 }}>
                    <View float style={{ padding:5, justifyContent:'center', alignItems:'center' }}>
                        <Text theme='h1'>${order_stats.resolved_stake.toFixed(2)}</Text>
                        <Text theme='light' style={{ marginTop:3 }}>Bet</Text>
                    </View>
                    <View float style={{ padding:5, justifyContent:'center', alignItems:'center', marginLeft:10 }}>
                        <Text theme='h1' color={getColor(order_stats.result_ind)}>${order_stats.winnings.toFixed(2)}</Text>
                        <Text theme='light' color={getColor(order_stats.result_ind)} style={{ marginTop:3 }}>Winnings</Text>
                    </View>
                </View>
                :
                <View style={{ flexDirection:'row', alignItems:'center', marginLeft:10 }}>
                    <View float style={{ padding:5, justifyContent:'center', alignItems:'center' }}>
                        <Text theme='h1'>${order_stats.unresolved_stake.toFixed()}</Text>
                        <Text theme='light' style={{ marginTop:3 }}>Bet</Text>
                    </View>
                    <View float style={{ padding:5, justifyContent:'center', alignItems:'center', marginLeft:10 }}>
                        <Text theme='h1' color={getColor(order_stats.result_ind)}>${order_stats.unresolved_potential_winnings.toFixed(2)}</Text>
                        <Text theme='light' color={getColor(order_stats.result_ind)} style={{ marginTop:3 }}>To Win</Text>
                    </View>
                </View>
                }
            </View>
        )
    }
    const order_stats = GolfHelpers.calcAllOrderStats(leader_orders);

    const renderSections = (data:{ item:string, index:number }) => {
        switch(data.item){
            case 'header':
                return (
                    <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                    <AthleteImage
                        athlete={athlete}
                        size={32}
                    />
                    <View transparent style={{ flex:1, marginLeft:10 }}>
                        <Text theme='h1'>{athlete.first_name} {athlete.last_name}</Text>
                        <Text theme='description' style={{ marginTop:4 }}>Current Hole {current_hole}</Text>
                    </View>
                    <View transparent style={{ marginRight:10 }}>
                        <Text theme='h1' color={order_stats.earnings < 0 ? Colors.text.error : order_stats.earnings == 0 ? Colors.text.descriptionLight : Colors.text.success}>${order_stats.earnings.toFixed(2)}</Text>
                        <Text theme='description' style={{ marginTop:3 }}>Earnings</Text>
                    </View>
                    <Button
                        title='X'
                        float
                        style={{ marginLeft:15, height:30, width:30, borderRadius:100, padding:0, justifyContent:'center', alignItems:'center' }}
                        onPress={() => onClose()}
                    />
                </View>
                )
            case 'toggle':
                return (
                    <View style={{ padding:10 }}>
                        <Toggle
                            options={[
                                { key: 'active', label: 'Active' },
                                { key: 'closed', label: 'Closed' }
                            ]}
                            onSelectOption={(option) => setActiveToggle(option)}
                            selected_option={active_toggle}
                        />
                    </View>
                )
            case 'list':
                return (
                    <View>
                        <FlatList
                            data={leader_orders}
                            renderItem={renderOrders}
                            key={'leader_bets_list'}
                            keyExtractor={(item) => item.order_id.toString()}
                        />
                    </View>
                )
            default: return <></>
        }
    }


    return (
        <View type='blur' style={{ position:'absolute', top:0, left:0, right:0, bottom:0, justifyContent:'flex-end' }}>
            <View float style={{ maxHeight:max_height }}>
                <FlatList
                    key='betlistsections'
                    keyExtractor={item => item}
                    renderItem={renderSections}
                    data={sections}
                />

                
            </View>
        </View>
    )
}

export default LeaderBetsList